import React, { useState, useEffect, useContext } from 'react'
import EditFilterGeneral from './../../../../components/Search/FilterList/EditFilterGeneral'
import EditFilterSettings from './../../../../components/Search/FilterList/EditFilterSettings'
import { ProductContext } from './../../../../store'
import { PostData } from './../../../../services/FetchData'
import DetailSkeleton from './../../../../components/Skeleton/DetailSkeleton'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

const EditFilter = () => {
	const { id } = useParams()
	const navigate = useNavigate()
	const [activeTab, setActiveTab] = useState('general')
	const [updateFlag, setUpdateFlag]	= useState(true)
	const [filter, setFilter]	= useState({})
	const [selectedFilters, setSelectedFilters]	= useState([])
	const [filterValuesLoader, setFilterValuesLoader] = useState(true)

	const {
		filterValues,
		currentFilter,
		updateCurrentFilter,
		getFilteredValues,
		updateFilterValues,
		applySortingToValues,
		currentWebsiteId
	} = useContext(ProductContext)

	// useEffect(() => {
	// 	if (filter && !currentFilter) {
	// 		updateCurrentFilter(filter);
	// 	}
	// }, [filter, currentFilter, updateCurrentFilter]);

	useEffect(() => {
		if (currentWebsiteId && id && updateFlag) {			
			fetchFilterValues()
			setUpdateFlag(false)
		}
	}, [currentWebsiteId, id, updateFlag])

	const fetchFilterValues = () => {
		setFilterValuesLoader(true)
		PostData("ms1", "api/v1/filters/getFilterValues", {websiteId: currentWebsiteId, filterId: id}).then(result => {
			if (result !== "Invalid" && result !== "undefined") {
				if (result.status === "success") {
					let filterValuesLocal	= result.data.filterValues,
						filtersLocal	= result.data.filter
					updateCurrentFilter(filtersLocal)
					updateFilterValues(filterValuesLocal)
					setFilter(filtersLocal)
					setFilterValuesLoader(false)
					// const filterValues = result.data.filterValues || []

					// if (filterValues.length === 0) {
					// 	// If no filter values exist, create them first
					// 	PostData("ms1", "api/v1/filters/createFilterValues", {
					// 		websiteId: currentWebsiteId,
					// 		facetId: filter?.facetId
					// 	}).then(createResult => {
					// 		if (createResult !== "Invalid" && createResult !== "undefined") {
					// 			if (createResult.status === "success") {
					// 				// After creating, fetch the filter values again
					// 				PostData("ms1", "api/v1/filters/getFilterValues", {
					// 					websiteId: currentWebsiteId,
					// 					facetId: filter?.facetId
					// 				}).then(finalResult => {
					// 					if (finalResult !== "Invalid" && finalResult !== "undefined") {
					// 						if (finalResult.status === "success") {
					// 							const finalFilterValues = finalResult.data.filterValues || []
					// 							const mappedFilterValues = finalFilterValues.map(item => ({
					// 								id: item.facetValueId,
					// 								facetId: item.facetId,
					// 								value: item.value,
					// 								displayName: item.displayName,
					// 								status: item.status,
					// 								pos: parseInt(item.pos)
					// 							}))

					// 							updateFilterValues(mappedFilterValues)
					// 						} else {
					// 							updateFilterValues([])
					// 						}
					// 					} else {
					// 						updateFilterValues([])
					// 					}
					// 					setFilterValuesLoader(false)
					// 				}).catch(error => {
					// 					updateFilterValues([])
					// 					setFilterValuesLoader(false)
					// 				})
					// 			} else {
					// 				updateFilterValues([])
					// 				setFilterValuesLoader(false)
					// 			}
					// 		} else {
					// 			updateFilterValues([])
					// 			setFilterValuesLoader(false)
					// 		}
					// 	}).catch(error => {
					// 		updateFilterValues([])
					// 		setFilterValuesLoader(false)
					// 	})
					// } else {
					// 	// Map API response to expected format
					// 	const mappedFilterValues = filterValues.map(item => ({
					// 		id: item.facetValueId,
					// 		facetId: item.facetId,
					// 		value: item.value,
					// 		displayName: item.displayName,
					// 		status: item.status,
					// 		pos: parseInt(item.pos)
					// 	}))

					// 	updateFilterValues(mappedFilterValues)
					// 	setFilterValuesLoader(false)
					// }
				} else if( result.status === "failure" ){
					toast.error(result.message)
					updateFilterValues([])
					setFilterValuesLoader(false)
					return navigate("/search/filter")
				}
			} else {
				updateFilterValues([])
				setFilterValuesLoader(false)
			}
		}).catch(error => {
			updateFilterValues([])
			setFilterValuesLoader(false)
		})
	}

	// Get filtered values based on current filter's facetId
	const getCurrentFilteredValues = () => {
		// Use the filter prop directly, not the global currentFilter
		if (!filter?.filterId) {
			return []
		}

		const filteredValues = getFilteredValues(filter.facetId)

		return filteredValues
	}

	// Handle position updates from drag-and-drop
	const handlePositionUpdate = (updatedValues) => {
		if (!filter?.facetId) return

		// Get all current values
		const allValues = getFilteredValues()
		const otherFacetValues = allValues.filter(v => v.facetId !== filter.facetId)
		const newAllValues = [...otherFacetValues, ...updatedValues]

		updateFilterValues(newAllValues)
	}

	const handleSave = (updatedData) => {

		// Update the global current filter state with new sorting information
		const currentFilterData = currentFilter || filter;
		const newFilter = {
			...currentFilterData,
			...updatedData,
		};
		updateCurrentFilter(newFilter);

		// If the updated data contains new filter values (from Settings page), update the global state
		if (updatedData.updatedFilterValues) {
			const currentFilterData = currentFilter || filter;
			if (currentFilterData?.facetId) {
				// Get all current values
				const allValues = getFilteredValues();
				const otherFacetValues = allValues.filter(
					(v) => v.facetId !== currentFilterData.facetId
				);
				const newAllValues = [
					...otherFacetValues,
					...updatedData.updatedFilterValues,
				];

				updateFilterValues(newAllValues);
			}
		}

		// Pass the updated data to parent
		//onSave(updatedData);
	};

	// Show loading state while fetching filter values
	if (filterValuesLoader) {
		return <DetailSkeleton />
	}

	return (
		<div className="editFilterContainer">
			{/* Back Button */}
			<div className="editFilterBackButton">
				<button className="backButton" onClick={() => {return navigate("/search/filter");}}>
					<i className="fa-solid fa-arrow-left"></i>
					Back
				</button>
			</div>

			{/* Heading */}
			<h1 className="filtersListHeading">Edit '{filter?.title}'</h1>

			{/* Tabs */}
			<div className="editFilterTabs">
				<button
					className={`editFilterTab ${activeTab === "general" ? "active" : ""}`}
					onClick={() => setActiveTab("general")}
				>
					General
				</button>
				<button
					className={`editFilterTab ${activeTab === "settings" ? "active" : ""
						}`}
					onClick={() => setActiveTab("settings")}
				>
					Settings
				</button>
			</div>

			{/* Tab Content */}
			<div className="editFilterTabContent">
				{activeTab === 'general' ? (
					<EditFilterGeneral />
				) : (
					<EditFilterSettings updateFlag={() => setUpdateFlag(true)} />
				)}
			</div>
		</div>
	);
};

export default EditFilter;
